import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utilities';

const initialState = {
  empresas: {
    loading: false,
    empresas: [],
    error: null,
    estaCargado: false
  },
  loadingCambiarEmpresa: false
};

//#region execute Cambiar Empresa
const cambiarEmpresa = (state, loading) => {
  return updateObject(state, {
    loadingCambiarEmpresa: loading
  });
};
//#endregion

//#region loadEmpresas
const loadEmpresasStart = (state) => {
  return updateObject(state, {
    empresas: updateObject(state.empresas, {
      loading: true,
      empresas: [],
      error: null,
      estaCargado: false
    })
  });
};

const loadEmpresasSuccess = (state, empresas) => {
  return updateObject(state, {
    empresas: updateObject(state.empresas, {
      loading: false,
      empresas,
      estaCargado: true
    })
  });
};

const loadEmpresasFail = (state, error) => {
  return updateObject(state, {
    empresas: updateObject(state.empresas, {
      loading: false,
      error,
      estaCargado: true
    })
  });
};
//#endregion

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_EMPRESAS_START:
      return loadEmpresasStart(state);
    case actionTypes.LOAD_EMPRESAS_SUCCESS:
      return loadEmpresasSuccess(state, action.empresas);
    case actionTypes.LOAD_EMPRESAS_FAIL:
      return loadEmpresasFail(state, action.error);

    case actionTypes.EXECUTE_CAMBIAR_EMPRESA:
      return cambiarEmpresa(state, action.loading);

    default:
      return state;
  }
};

export default reducer;
